var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08646 1.78767L11.1222 3.72556C11.208 3.8072 11.208 3.94041 11.1222 4.02205L6.19306 8.71423L4.09861 8.93552C3.81875 8.9656 3.58177 8.74001 3.61337 8.47361L3.84583 6.47986L8.775 1.78767C8.86076 1.70603 9.00069 1.70603 9.08646 1.78767ZM12.7427 1.29568L11.6413 0.247241C11.2983 -0.0793213 10.7408 -0.0793213 10.3955 0.247241L9.59653 1.00779C9.51076 1.08943 9.51076 1.22263 9.59653 1.30427L11.6323 3.24216C11.7181 3.3238 11.858 3.3238 11.9438 3.24216L12.7427 2.48162C13.0858 2.15291 13.0858 1.62224 12.7427 1.29568ZM8.66667 7.43806V9.62517H1.44444V2.75017H6.6309C6.70312 2.75017 6.77083 2.72224 6.82274 2.67498L7.72552 1.8156C7.89705 1.65232 7.77517 1.37517 7.53368 1.37517H1.08333C0.485243 1.37517 0 1.83709 0 2.40642V9.96892C0 10.5383 0.485243 11.0002 1.08333 11.0002H9.02778C9.62587 11.0002 10.1111 10.5383 10.1111 9.96892V6.57869C10.1111 6.3488 9.81997 6.23494 9.64844 6.39607L8.74566 7.25544C8.69601 7.30486 8.66667 7.36931 8.66667 7.43806Z",
    fill: "#27509F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4f0036b563f6106af7f7057b59b982d0.svg";
export { ForwardRef as ReactComponent };